import { render, staticRenderFns } from "./VueSwiper.vue?vue&type=template&id=ccf0cac4&scoped=true"
import script from "./VueSwiper.vue?vue&type=script&lang=js"
export * from "./VueSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf0cac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccf0cac4')) {
      api.createRecord('ccf0cac4', component.options)
    } else {
      api.reload('ccf0cac4', component.options)
    }
    module.hot.accept("./VueSwiper.vue?vue&type=template&id=ccf0cac4&scoped=true", function () {
      api.rerender('ccf0cac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueSwiper.vue"
export default component.exports